import React from 'react'
import Header from '../Components/Header/Header'
import Content from '../Components/Home/Content/Content'

function Homepage() {
    return (
        <>
       <Header/>
        <Content/>
        
        </>
    )
}

export default Homepage
